export class PieceRateSiteWeek
{
    id: number;
    siteId: string;
    closed: boolean;
    combinedShifts: boolean;
}
